import { useMemo } from "react"
import { useGetSingleFinancialModelSettingsV2Query } from "@/feature/financial-model/api"

import { getOwcModuleCompletitionStatus } from "../utils"

export const useOwcSetupStatus = (financial_model_id: string) => {
  const { data: owcSetupSettings, isLoading: isLoadingSetupSettings } =
    useGetSingleFinancialModelSettingsV2Query({
      id: financial_model_id,
      module: `owc`,
      section: `setup`,
    })

  const isCurrentAssetsSetupCompleted = useMemo(
    () =>
      !isLoadingSetupSettings &&
      getOwcModuleCompletitionStatus(
        `owc_assets`,
        owcSetupSettings?.owc.settings!
      ) === `done`,
    [owcSetupSettings, isLoadingSetupSettings]
  )

  const isCurrentLiabilitiesSetupCompleted = useMemo(
    () =>
      !isLoadingSetupSettings &&
      getOwcModuleCompletitionStatus(
        `owc_liabilities`,
        owcSetupSettings?.owc.settings!
      ) === `done`,
    [owcSetupSettings, isLoadingSetupSettings]
  )

  const isTaxesSetupCompleted = useMemo(
    () =>
      !isLoadingSetupSettings &&
      getOwcModuleCompletitionStatus(
        `owc_receivables`,
        owcSetupSettings?.owc.settings!
      ) === `done`,
    [owcSetupSettings, isLoadingSetupSettings]
  )

  return {
    isLoading: isLoadingSetupSettings,

    isCurrentAssetsSetupCompleted,
    isCurrentLiabilitiesSetupCompleted,
    isTaxesSetupCompleted,
    owcSetupSettings,
  }
}
